import { render, staticRenderFns } from "./LoginDefault.vue?vue&type=template&id=4a37b123&"
import script from "./LoginDefault.vue?vue&type=script&lang=js&"
export * from "./LoginDefault.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports